import { COLUMN_CLASS, LIST_TAGS, TABLE_TAGS } from "../constants";
import { isBlankText, isBr, isElement, isTag, isText } from "../helpers";

const splitAtBr = (run: Node[]): Node[][] => {
  const pieces: Node[][] = [[]];
  run.forEach((node) => {
    if (isBr(node)) pieces.push([]);
    else pieces[pieces.length - 1].push(node);
  });
  return pieces.map((piece) => piece.filter((node) => !isBlankText(node))).filter((piece) => piece.length > 0);
};

const trimPiece = (piece: Node[]) => {
  const first = piece[0];
  const last = piece[piece.length - 1];
  if (isText(first)) first.data = first.data.replace(/^\s+/, "");
  if (isText(last)) last.data = last.data.replace(/\s+$/, "");
};

const buildColumn = (doc: Document, pieces: Node[][]) => {
  const column = doc.createElement("div");
  column.className = COLUMN_CLASS;
  pieces.forEach((piece) => {
    if (piece.length === 1 && isElement(piece[0])) {
      column.appendChild(piece[0]);
      return;
    }
    trimPiece(piece);
    const wrapper = doc.createElement("div");
    piece.forEach((node) => wrapper.appendChild(node));
    column.appendChild(wrapper);
  });
  return column;
};

const restructureRun = (parent: Node, run: Node[]) => {
  const doc = parent.ownerDocument;
  if (!doc || !run.some(isBr)) return;
  const marker = parent.insertBefore(doc.createTextNode(""), run[0]);
  parent.replaceChild(buildColumn(doc, splitAtBr(run)), marker);
  run.forEach((node) => {
    if (node.parentNode === parent) parent.removeChild(node);
  });
};

const structureNode = (node: Node, skip: (el: Element) => boolean) => {
  if (isElement(node) && skip(node)) return;

  Array.from(node.childNodes).forEach((child) => {
    if (!isElement(child)) return;
    try {
      structureNode(child, skip);
    } catch {
      return;
    }
  });

  if (isElement(node) && TABLE_TAGS.includes(node.tagName)) return;

  const children = Array.from(node.childNodes);
  if (!(isElement(node) && LIST_TAGS.includes(node.tagName))) {
    restructureRun(node, children);
    return;
  }

  let run: Node[] = [];
  children.forEach((child) => {
    if (isTag(child, "LI")) {
      restructureRun(node, run);
      run = [];
    } else {
      run.push(child);
    }
  });
  restructureRun(node, run);
};

export { structureNode };
